import { FC, useCallback, useState } from 'react';
import { ISwitchProps } from './types';

export const Switch: FC<ISwitchProps> = ({ isActive, onChange, disabled }) => {
  const [status, setStatus] = useState(isActive);

  const onSwitch = useCallback(() => {
    setStatus((prev) => !prev);
    onChange(!isActive);
  }, [isActive]);

  return (
    <button
      type="button"
      onClick={onSwitch}
      disabled={disabled}
      className={`
        relative w-[28px] h-[16px] rounded-full p-[2px] transition-all duration-300
        ${status ? 'bg-gradient-to-b from-[#b5f109] to-[#4fb301]' : 'bg-[#a3aab3]'}
        ${!disabled ? 'cursor-pointer' : 'cursor-default'}
      `}
    >
      <span
        className={`
          block w-[12px] h-[12px] rounded-full bg-white absolute top-[2px] transition-transform duration-300
          ${status ? 'translate-x-[12px]' : 'translate-x-0'}
        `}
      />
    </button>
  );
};
